import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';

export const mentionCommand = ({ editor, range }) =>
  range
    ? editor.chain().focus().deleteRange(range).insertContent('@').run()
    : editor.chain().focus().insertContent('@').run();

const Mention = ({ editor, showLabel = false, indicateActive = true, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container !bg-transparent`}
      icon={<div className="text-gray-800 text-xs font-weight-500">@</div>}
      onClick={isExtension ? () => {} : () => mentionCommand({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="MENTION" defaultMessage="Mention" />
        </div>
      )}
    </Button>
  );
};

export default Mention;
